import { FeatureFlags } from "@utils/FeatureFlags/generated-flags";
import { useFlags } from "launchdarkly-react-client-sdk";
import React from "react";
import { useSearchParams } from "react-router-dom";

import { LegacyUploadFiles } from "@pages/AssessmentReportV2Details/AssessmentReportSubPages/UploadFiles/LegacyUploadFiles";
import { NewIAUploadFiles } from "@pages/AssessmentReportV2Details/AssessmentReportSubPages/UploadFiles/NewIAUploadFiles";

// `?upload-flow=bulk|legacy` overrides the flag for side-by-side QA. Anything else falls back to the flag.
const resolveUseBulk = (queryParam: string | null, flagOn: boolean): boolean => {
  if (queryParam === "bulk") return true;
  if (queryParam === "legacy") return false;
  return flagOn;
};

export const UploadFiles: React.FC = () => {
  const flags = useFlags<FeatureFlags>();
  const [searchParams] = useSearchParams();
  const queryParam = searchParams.get("upload-flow");

  if (queryParam === "both") {
    return (
      <div className="flex w-full flex-row items-start gap-x-4">
        <div className="flex w-1/2 min-w-0 flex-col">
          <div className="mb-2 text-xs font-semibold uppercase tracking-wide text-text-tertiary">Legacy</div>
          <LegacyUploadFiles />
        </div>
        <div className="sticky top-4 flex max-h-[calc(100vh-2rem)] w-1/2 min-w-0 flex-col self-start overflow-y-auto">
          <div className="mb-2 text-xs font-semibold uppercase tracking-wide text-text-tertiary">Bulk (new)</div>
          <NewIAUploadFiles />
        </div>
      </div>
    );
  }

  const useBulk = resolveUseBulk(queryParam, flags["ia-bulk-upload"]);
  return <div className="px-14 py-4">{useBulk ? <NewIAUploadFiles /> : <LegacyUploadFiles />}</div>;
};
